export default {
    challenge: {},
    challenges: [],
    class: {},
    myClasses: [],
    user: {},
}
